import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconEmail(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6Zm-2 0-8 5-8-5h16Zm0 12H4V8l8 5 8-5v10Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
